<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="top_line"></div>
    <div class="d_wrap">
      <h2 class="wrap_title">{{ newInfo[`${currentLang.prefix}title`] }}</h2>
      <div class="wrap_one">
        <div>
          {{
            newInfo.publish_time_txt
              ? newInfo.publish_time_txt
              : newInfo.create_time_txt
          }}
        </div>
        <span v-if="newInfo.activeNameText">{{ newInfo.activeNameText }}</span>
      </div>
      <template v-if="activeText === '产品案例' || activeText === '服务案例' || activeText === '检修案例'">
        <div class="detail_content_wrap">
          <div class="content_wrap_left" @click="seeImageBig">
            <img :src="newInfo.full_image" alt="" />
          </div>
          <div class="content_wrap_right">
            <p>
              <span>{{ productProgramPage.contentTitle1 }}:</span>{{ newInfo.area }}
            </p>
            <p>
              <span>{{ productProgramPage.contentTitle2 }}:</span>{{ newInfo.customer }}
            </p>
            <p>
              <span>{{ productProgramPage.contentTitle3 }}:</span>{{ newInfo.product }}
            </p>
            <p>
              <span>{{ productProgramPage.contentTitle4 }}:</span>{{ newInfo.industry }}
            </p>
            <p>
              <span>{{ productProgramPage.contentTitle5 }}:</span>{{ newInfo.mediainfo }}
            </p>
          </div>
        </div>
      </template>
      <div class="wrap_two article_details" v-html="$convertPxToRem(newInfo[`${currentLang.prefix}content`])"></div>

      <!-- 返回按钮 -->
      <div style="width:100%;margin:30px 0;display:flex;justify-content:flex-end;border-bottom:1px solid #ccc;">
        <back-button>
          <i slot="prefixIcon"></i>
          {{ productProgramPage.backPreviousPageTxt }}
          <i slot="suffixIcon" class="el-icon-arrow-right"></i>
        </back-button>
      </div>
    </div>
    <div id="big-image" class="modal" v-if="imageShow">
      <span class="close" @click="seeImageBig">&times;</span>
      <img :src="newInfo.full_image" alt="" class="large-image" />
    </div>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCase } from "@/utils/http.js";
export default {
  data() {
    return {
      newInfo: {},
      imageShow: false,
      activeText: ""
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    newsPage() {
      return this.currentLang.config.newsPage;
    },
    navbar() {
      return this.currentLang.config.navbar;
    },
    productProgramPage() {
      return this.currentLang.config.productProgramPage;
    }
  },

  mounted() {
    this.activeText = this.$route.query.title;
    this.getNewDetails();
  },
  methods: {
    getNewDetails() {
      getCase({
        id: this.$route.query.id
      }).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.newInfo = res.data;
          const { tabs } = this.newsPage
          tabs.forEach(item => {
            console.log(this.$route.query.activeNameText,item.title)
            if (item.title === this.$route.query.activeNameText) {
              this.$set(
            this.newInfo,
            "activeNameText",
            item[`${this.currentLang.prefix}title`] 
          );
            }
          });
          
        }
      });
    },
    seeImageBig() {
      this.imageShow = !this.imageShow;
    }
  }
};
</script>
<style lang="scss">
.top_line {
  width: 100%;
  height: 1px;
  background: #999999;
}

.d_wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1000px;
  width: 1200px;
  margin: 80px auto 0 auto;

  .wrap_title {
    text-align: center;
  }

  .wrap_one {
    display: flex;
    font-size: 16px;
    justify-content: center;
    margin: 20px 0;
    text-align: center;

    div {
      color: #999999;
    }

    span {
      color: #30506f;
      margin-left: 20px;
    }
  }

  .wrap_two {
    margin-bottom: 80px;
    font-size: 16px;
    line-height: 1.8;
    // text-indent: 2rem;
    color: #666;
  }
}

.wrap_four {
  width: 100%;
  text-align: center;
  margin-top: 80px;
  padding: 80px 0;
  background: #f5f5f5;

  h2 {
    color: #09395e;
    margin-bottom: 50px;
  }

  p {
    color: #656565;
    margin-top: 10px;
  }

  span {
    padding: 10px 25px;
    border-radius: 5px;
    color: white;
    background: #e8363e;
  }
}

h2 {
  font-weight: normal;
}

.modal {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal img {
  margin: auto;
  display: block;
  width: 800px;
  height: 800px;
}

.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

.detail_content_wrap {
  width: 100%;
  margin-top: 50px;
  display: flex;

  .content_wrap_left {
    width: 400px;
    height: 400px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .content_wrap_right {
    margin-left: 45px;

    p {
      color: #323232;
      text-align: left;
      margin-top: 25px;
    }

    span {
      font-weight: bold;
      margin-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/nText.vue